import React, { useEffect, useRef, useState } from "react";
import "./HoverTagList.css";

export const HoverTagItem = ({ title, description ,disableBg=false ,customAlign}) => {
  const wrapperRef = useRef(null);
  const tooltipRef = useRef(null);
  const [alignClass, setAlignClass] = useState("align-center");

const adjustTooltipPosition = () => {
  const wrapper = wrapperRef.current;
  const tooltip = tooltipRef.current;
  if (!wrapper || !tooltip) return;

  const wrapperRect = wrapper.getBoundingClientRect();
  const tooltipWidth = tooltip.offsetWidth;
  const viewportWidth = window.innerWidth;
  const margin = 10; // ~1vh

  const wrapperCenter = wrapperRect.left + wrapperRect.width / 2;
  const centerLeft = wrapperCenter - tooltipWidth / 2;
  const centerRight = wrapperCenter + tooltipWidth / 2;

  const isNearLeft = wrapperRect.left <= margin;
  const isNearRight = wrapperRect.right >= viewportWidth - margin;

  if (isNearLeft) {
    setAlignClass("align-left-margin");
  } else if (isNearRight) {
    setAlignClass("align-right-margin");
  } else if (centerLeft >= margin && centerRight <= viewportWidth - margin) {
    setAlignClass("align-center");
  } else {
    // Fallback if tooltip is wider than screen
    setAlignClass("align-left-margin");
  }

  if (customAlign) {
    setAlignClass("align-right-margin"); 
  }
};




  useEffect(() => {
    adjustTooltipPosition();
    window.addEventListener("resize", adjustTooltipPosition);
    return () => window.removeEventListener("resize", adjustTooltipPosition);
  }, []);

  return (
    <div className="hover-tag-wrapper" ref={wrapperRef} onMouseEnter={adjustTooltipPosition}>
      <div ref={tooltipRef} className={`tooltip ${alignClass}`}>
        {description}
      </div>
      <div className={disableBg?null:"hover-tag"}>
        {title}
       
      </div>
    </div>
  );
};

const HoverTagList = ({ items,disableBg,customAlign="left" }) => (
  <div className="hover-tag-container">
    {items.map((item, index) => (
       <HoverTagItem key={index} title={item.title} description={item.description}  disableBg={disableBg} customAlign={customAlign}/>
     
    ))}
  </div>
);

export default HoverTagList;
